import styled, { keyframes } from 'styled-components'

const AnimatedSuccess = keyframes`
 0% {
    opacity: 0;
		transform: scale(0.7);
		box-shadow: 0 0 0 0 rgba(0, 170, 79, 0.7);
	}

	70% {
    opacity: 1;
		transform: scale(1.1);
		box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
	}

	100% {
    opacity: 1;
    transform: scale(1);
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
	}
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  min-height: calc(100vh - 54px);
`

export const Header = styled.div`
  margin-top: 40px;

  h2 {
    margin-top: 40px;
  }

  p {
    margin-top: 8px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 24px 0;
`

export const Sign = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 64px;
  margin: 0 auto;
  border-radius: 50%;
  opacity: 0;
`
export const SuccessSign = styled(Sign)`
  animation: ${AnimatedSuccess} 2s 0.3s forwards;
  background-color: var(--success500);
`
export const Footer = styled.div`
  margin-top: auto;

  button {
    margin-bottom: 16px;
  }
`
